export enum AnswerProgressType {
	bar = 'bar',
	num = 'num',
}
